"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuItemsWrapper = _interopRequireDefault(require("../MenuItemsWrapper"));

var _SubNavMenu = require("./SubNavMenu.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** SubNavMenu component.
 * Container for desktop and mobile renderings.
 * It takes an array of options as props. options should contain an id, label and callback function
 * Active is determined by matching the activeMenuId to the id of the active option
 */
var SubNavMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SubNavMenu, _React$PureComponent);

  var _super = _createSuper(SubNavMenu);

  function SubNavMenu() {
    var _this;

    _classCallCheck(this, SubNavMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getItems", function () {
      var _this$props = _this.props,
          activeId = _this$props.activeId,
          options = _this$props.options;
      return options.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_SubNavMenu.MenuItemWrapper, {
          key: "c-subnav-".concat(item.id.toLowerCase().replace(/\s+/g, '-'))
        }, /*#__PURE__*/_react.default.createElement(_SubNavMenu.StyledMenuItem, {
          dataTestId: "c-subnav-".concat(item.id.toLowerCase().replace(/\s+/g, '-')),
          onClick: item.callback,
          active: item.id === activeId
        }, item.label));
      });
    });

    return _this;
  }

  _createClass(SubNavMenu, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/_react.default.createElement(_MenuItemsWrapper.default, {
        className: className
      }, this.getItems());
    }
  }]);

  return SubNavMenu;
}(_react.default.PureComponent);

_defineProperty(SubNavMenu, "propTypes", {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Hook for overriding top-level component styles */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    callback: _propTypes.default.func
  })).isRequired,

  /** The Id of the item to be active */
  activeId: _propTypes.default.string
});

_defineProperty(SubNavMenu, "defaultProps", {
  className: '',
  activeId: '-999999'
});

var _default = SubNavMenu;
exports.default = _default;